import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styles from './GettingStarted.module.scss'
import Analytics from 'analytics'

const primaryButtonClasses = classnames(
  'button',
  'button--primary',
  styles.submitButton
)

const GettingStarted = (props) => {
  const {
    goToNextSection,
    linkHref,
  } = props


  const handleGetStartedClick = () => {
    Analytics.track('User clicks Lets Get Started')
    goToNextSection()
  }

  const handleEmailClick = () => {
    Analytics.track('User clicks Private Wealth Management')
  }

  const pwmLink = (<a onClick={handleEmailClick} href={linkHref}>Private Wealth Management team</a>)

  return (
    <div className={styles.GettingStarted}>
      <p className={styles.subDescription}>
        We need your help to fill in the account opening forms from
        the broker-dealer for your account,
        Charles Schwab, Inc. (aka “Schwab”).
      </p>
      <p className={styles.subDescription}>
        You can always reach out to the {pwmLink} if you have questions.
      </p>
      <button className={primaryButtonClasses} type="submit" onClick={handleGetStartedClick}>Let’s Get Started</button>
    </div>
  )
}

GettingStarted.propTypes = {
  goToNextSection: PropTypes.func.isRequired,
  linkHref: PropTypes.string.isRequired,
}

export default GettingStarted



// WEBPACK FOOTER //
// ./src/components/Onboarding/GettingStarted/v1/GettingStarted.jsx